const SET_IS_LOGIN = (state, isLogin) => {
  state.isLogin = isLogin;
};

const SET_DANH_SACH_DON_VI_VA_CHUC_VU = (state, danhSachDonViVaChucVu) => {
  state.danhSachDonViVaChucVu = danhSachDonViVaChucVu;
};

const SET_DANH_SACH_QUYEN = (state, danhSachQuyen) => {
  state.danhSachQuyen = danhSachQuyen;
};

const SET_DANH_SACH_CAN_BO = (state, danhSachCanBo) => {
  state.danhSachCanBo = danhSachCanBo;
};

const SET_NHIEM_VU_CA_NHAN_TAB_INDEX = (state, nhiemVuCaNhanTabIndex) => {
  state.nhiemVuCaNhanTabIndex = nhiemVuCaNhanTabIndex;
};

const LAY_LIST_DON_VI_NGOAI_THANH_CONG = (state, listDonViNgoai) => {
  state.listDonViNgoai = listDonViNgoai;
};

const LAY_LIST_DON_VI_TRONG_THANH_CONG = (state, listDonViTrong) => {
  state.listDonViTrong = listDonViTrong;
};

const LAY_LIST_CAN_BO_TRONG_THANH_CONG = (state, listCanBo) => {
  state.listCanBo = listCanBo;
};


const LAY_LIST_LOAI_VAN_BAN_THANH_CONG = (state, listLoaiVanBan) => {
  state.listLoaiVanBan = listLoaiVanBan;
};

const LAY_LIST_DO_KHAN_THANH_CONG = (state, listDoKhan) => {
  state.listDoKhan = listDoKhan;
};

const LAY_LIST_LUONG_KY_DUYET_THANH_CONG = (state, listLuongKyDuyet) => {
  state.listLuongKyDuyet = listLuongKyDuyet;
};

const LAY_MULTI_DON_VI_TRONG = (state, multiDonViTrong) => {
  state.multiDonViTrong = multiDonViTrong;
};

const LAY_MULTI_DON_VI_NGOAI = (state, multiDonViNgoai) => {
  state.multiDonViNgoai = multiDonViNgoai;
};

const LAY_MULTI_CAN_BO = (state, multiCanBo) => {
  state.multiCanBo = multiCanBo;
};

const LAY_MULTI_NGUOI_DUNG = (state, multiNguoiDung) => {
  state.multiNguoiDung = multiNguoiDung;
};

const LAY_ALL_SO_DEN_THANH_CONG = (state, allSoDen) => {
  state.allSoDen = allSoDen;
};

const LAY_ALL_SO_DI_THANH_CONG = (state, allSoDi) => {
  state.allSoDi = allSoDi;
};

const LAY_ALL_SO_DEN_TRA_CUU_THANH_CONG = (state, allSoDen) => {
  state.allSoDenTraCuu = allSoDen;
};

const SET_THONG_TIN_USER = (state, data) => {
  state.thongTinUser = data;
};

const SET_DON_VI_TRONG_IGNORE = (state, danhSachDonViTrongIgnore) => {
  state.danhSachDonViTrongIgnore = danhSachDonViTrongIgnore;
};

const SET_DON_VI_NGOAI_IGNORE = (state, danhSachDonViNgoaiIgnore) => {
  state.danhSachDonViNgoaiIgnore = danhSachDonViNgoaiIgnore;
};

const SET_LOADING_SUBMIT = (state, isLoading) => {
  state.isLoading = isLoading;
};

const SET_DANH_SACH_CAN_BO_VAN_THU = (state, danhSachCanBoVanThu) => {
  state.danhSachCanBoVanThu = danhSachCanBoVanThu;
};

const SET_DON_VI_TRONG_NGOAI = (state, danhSachDonViTrongNgoai) => {
  state.danhSachDonViTrongNgoai = danhSachDonViTrongNgoai;
};

const SET_SCAN_STATUS = (state, data) => {
  state.scanStatus = data;
}
const SET_DANH_SACH_COT_HIEN_THI = (state , data) => {
  state.danhSachCotHienThi = data
}
const LAY_LIST_CAN_BO_SOAN_THAO = (state, listCanBoSoanThao) => {
  state.listCanBoSoanThao = listCanBoSoanThao;
};

const SET_IS_RELOAD_LIST = (state, payload) => {
  state.isReloadList = payload;
}

const SET_INFO_FILTER_TRA_CUU = (state, infFilterTraCuu) => {
  state.infFilterTraCuu = infFilterTraCuu;
}

const SET_IS_IFRAME = (state, payload) => {
  state.isIframe = payload
}

export default {
  SET_DON_VI_TRONG_IGNORE,
  SET_INFO_FILTER_TRA_CUU,
  SET_DON_VI_NGOAI_IGNORE,
  SET_DANH_SACH_CAN_BO,
  SET_IS_LOGIN,
  SET_DANH_SACH_DON_VI_VA_CHUC_VU,
  SET_DANH_SACH_QUYEN,
  SET_NHIEM_VU_CA_NHAN_TAB_INDEX,
  LAY_LIST_DON_VI_NGOAI_THANH_CONG,
  LAY_LIST_DON_VI_TRONG_THANH_CONG,
  LAY_LIST_CAN_BO_TRONG_THANH_CONG,
  LAY_LIST_LOAI_VAN_BAN_THANH_CONG,
  LAY_LIST_DO_KHAN_THANH_CONG,
  LAY_LIST_LUONG_KY_DUYET_THANH_CONG,
  LAY_MULTI_DON_VI_TRONG,
  LAY_MULTI_DON_VI_NGOAI,
  LAY_MULTI_CAN_BO,
  LAY_ALL_SO_DEN_THANH_CONG,
  LAY_ALL_SO_DEN_TRA_CUU_THANH_CONG,
  SET_THONG_TIN_USER,
  SET_LOADING_SUBMIT,
  SET_DANH_SACH_CAN_BO_VAN_THU,
  SET_DON_VI_TRONG_NGOAI,
  SET_SCAN_STATUS ,
  SET_DANH_SACH_COT_HIEN_THI,
  LAY_LIST_CAN_BO_SOAN_THAO,
  SET_IS_RELOAD_LIST,
  SET_IS_IFRAME,
  LAY_ALL_SO_DI_THANH_CONG,
  LAY_MULTI_NGUOI_DUNG,
};
